import { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../Styles/Header.scss";
import logo from "../Image/logo.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // solid background after scroll
      setScrolled(currentScrollY > 80);

      // hide / show on scroll direction
      if (currentScrollY > lastScrollY && currentScrollY > 120) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`header ${scrolled ? "scrolled" : ""} ${
        hidden ? "hidden" : ""
      }`}
    >
      <div className="header-inner">
        <div className="logo">
          <Link to="/">
            {" "}
            <img src={logo} alt="Kurti Hotel" />
          </Link>
        </div>

        <nav className={`nav ${open ? "show" : ""}`}>
          <div className="nav-close" onClick={() => setOpen(false)}>
            <FaTimes />
          </div>

          <a href="/" onClick={() => setOpen(false)}>
            Home
          </a>
          <a href="/rooms" onClick={() => setOpen(false)}>
            Rooms
          </a>
          <a href="/about" onClick={() => setOpen(false)}>
            About
          </a>
          <a href="/gallery" onClick={() => setOpen(false)}>
            Gallery
          </a>
          <Link to="/contact">
            <button className="contact-btn" onClick={() => setOpen(false)}>
              Contact Us
            </button>
          </Link>
        </nav>

        <div className="burger" onClick={() => setOpen(!open)}>
          {open ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </header>
  );
};

export default Header;
